
import type { SVGProps } from 'react';
const SvgDiversity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#diversity_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M5.36 17.123a.35.35 0 0 0 .072-.49A8.65 8.65 0 0 1 3.7 11.419c0-2.317.898-4.497 2.53-6.141A8.66 8.66 0 0 1 12.418 2.7c2.253 0 4.39.856 6.02 2.412a.35.35 0 1 0 .484-.507A9.38 9.38 0 0 0 12.418 2c-2.529 0-4.903.989-6.685 2.784A9.36 9.36 0 0 0 3 11.42c0 2.049.647 3.997 1.87 5.633a.35.35 0 0 0 .49.071m14.235-.103a.351.351 0 0 1 .563.418 9.35 9.35 0 0 1-7.472 3.762 9.22 9.22 0 0 1-5.552-1.84.35.35 0 1 1 .419-.561 8.53 8.53 0 0 0 5.133 1.7 8.64 8.64 0 0 0 6.909-3.479m-7.476 2.108a.35.35 0 0 1-.384.313 7.876 7.876 0 0 1-7.09-7.86c0-.652.08-1.3.236-1.925a.351.351 0 0 1 .68.17 7.2 7.2 0 0 0-.215 1.754 7.177 7.177 0 0 0 6.46 7.164.35.35 0 0 1 .313.384m5.768-1.857a.35.35 0 0 1-.248-.598 7.16 7.16 0 0 0 2.11-5.093c0-3.97-3.23-7.201-7.202-7.201a.35.35 0 0 1 0-.701c4.358 0 7.903 3.545 7.903 7.902 0 2.111-.822 4.095-2.315 5.588a.35.35 0 0 1-.248.103m-9.961-6.662a.35.35 0 1 1 .686.14 4.021 4.021 0 0 0 3.935 4.827 4.02 4.02 0 0 0 4.017-4.016 4 4 0 0 0-1.176-2.84 4 4 0 0 0-2.84-1.177.35.35 0 0 1 0-.7c1.26 0 2.444.49 3.335 1.38a4.69 4.69 0 0 1 1.382 3.337 4.723 4.723 0 0 1-4.718 4.717 4.723 4.723 0 0 1-4.621-5.668m-.993 3.616a.35.35 0 0 0 .63-.307 5.545 5.545 0 0 1 4.984-7.955c1.843 0 3.56.913 4.593 2.442a.35.35 0 1 0 .58-.392 6.24 6.24 0 0 0-5.172-2.75 6.246 6.246 0 0 0-6.24 6.239c0 .954.21 1.87.625 2.723m11.177-.754a.35.35 0 0 1 .186.46 6.23 6.23 0 0 1-5.748 3.81 6.2 6.2 0 0 1-2.596-.564.35.35 0 1 1 .292-.638c.725.332 1.5.5 2.303.5a5.53 5.53 0 0 0 5.103-3.382.35.35 0 0 1 .46-.186"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="diversity_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDiversity;
